export type ChannelHint = "auto" | "STREAM" | "EMAIL" | "SMS" | "WHATSAPP";

export type ResolvedChannelValue =
  | "STREAM_ONLY"
  | "IN_APP"
  | "EMAIL"
  | "SMS"
  | "WHATSAPP";

export interface SendExternalChatMessageRequest {
  streamChannelId: string;
  text: string;
  channel: ChannelHint;
  media?: SendExternalChatMedia;
  whatsappTemplateName?: string;
  whatsappTemplateVariables?: Record<string, string>;
}

export interface SendExternalChatMedia {
  url: string;
  mimeType: string;
  caption?: string;
  filename?: string;
}

export interface SendExternalChatMessageResponse {
  deliveryId: string;
  channel: ResolvedChannelValue;
}

export const MAX_EXTERNAL_MESSAGE_LENGTH = 8000;
